import { render, staticRenderFns } from "./chart-pie.vue?vue&type=template&id=3150c4b6&scoped=true&"
import script from "./chart-pie.vue?vue&type=script&lang=js&"
export * from "./chart-pie.vue?vue&type=script&lang=js&"
import style0 from "./chart-pie.vue?vue&type=style&index=0&id=3150c4b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3150c4b6",
  null
  
)

export default component.exports